import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import i18n from 'i18n-js'
import { ImPlus, ImMinus } from 'react-icons/im'

import Input from '../../UI/Input/Input'
import Select from '../../UI/Select/Select'
import Artifacts from '../Artifacts/Artifacts'
import DamageResult from '../DamageResult/DamageResult'
import EHPResult from '../../EHPCalculator/EHPResult/EHPResult'

import './BaleDamage.scss'

const BaleDamage = props => {
    const monsters = useSelector(state => state.monsters)
    const [showArtifacts, setShowArtifacts] = useState(false)
    const bale = monsters.find(el => el.name === 'Baleygr')

    const [resultData, setResultData] = useState({
        baseATK: bale.atk,
        baseDEF: bale.def,
        baseHP: bale.hp,
        baseSPD: bale.spd,
        runesATK: 0,
        runesDEF: 0,
        runesHP: 0,
        runesSPD: 0,
        cdmg: bale.cdmg,
        skillUp: 0
    })

    const [runes, setRunes] = useState([
        {
            type: 'tel',
            id: 'hp',
            value: 0,
            label: i18n.t('hp_label'),
            maxLength: 5,
            hideLabel: true
        },
        {
            type: 'tel',
            id: 'atk',
            value: 0,
            label: i18n.t('atk_label'),
            maxLength: 4,
            hideLabel: true
        },
        {
            type: 'tel',
            id: 'def',
            value: 0,
            label: i18n.t('def_label'),
            maxLength: 4,
            hideLabel: true
        },
        {
            type: 'tel',
            id: 'spd',
            value: 0,
            label: i18n.t('spd_label'),
            maxLength: 3,
            hideLabel: true
        },
        {
            type: 'tel',
            id: 'cdmg',
            value: bale.cdmg,
            label: i18n.t('cdmg_label'),
            maxLength: 3,
            hideLabel: true
        }
    ])

    const [skillUp, setSkillUp] = useState({
        id: 'skill_up',
        label: 'skill_up_label',
        value: 0,
        options: [
            {
                value: 0
            },
            {
                value: 5
            },
            {
                value: 15
            },
            {
                value: 30
            }
        ]
    })

    const [artifacts, setArtifacts] = useState({
        atk_effect: 0,
        s3_damage: 0,
        dmg_percentage_hp: '',
        dmg_percentage_atk: 0,
        dmg_percentage_def: 0,
        dmg_percentage_spd: 0
    })

    const updateForm = (evt, id) => {
        evt.preventDefault()
        const value = parseInt(evt.target.value || 0)

        if (id === 'skill_up') {
            setSkillUp({
                ...skillUp,
                value: value
            })
            setResultData({
                ...resultData,
                skillUp: value
            })
        } else {
            const oldRunes = runes
            const runeIndex = runes.findIndex(el => el.id === id)
            const oldRune = runes.find(el => el.id === id)
            const newRune = {
                ...oldRune,
                value: value
            }
            const newRunes = [
                ...oldRunes.slice(0, runeIndex),
                newRune,
                ...oldRunes.slice(runeIndex + 1)
            ]

            let objectIdentifier = `runes${id.toUpperCase()}`

            if (id === 'cdmg') {
                objectIdentifier = 'cdmg'
            }

            setRunes(newRunes)
            setResultData({
                ...resultData,
                [objectIdentifier]: value
            })
        }
    }

    const onArtifactChange = (evt, id) => {
        evt.preventDefault()
        let value = parseInt(evt.target.value || 0)
        if (id === 'dmg_percentage_hp') {
            value = parseFloat(evt.target.value)
        }

        setArtifacts({
            ...artifacts,
            [id]: value
        })
    }

    return <div className="BaleDamage">

        <div className="card">
            <div className="card-img">
                <img src={`https://mogget24.bitbucket.io/sw/icons/${bale['name'].toLowerCase()}.png`} alt="" />
                <button type="button" className="toggle_artifacts d-md-none" onClick={() => setShowArtifacts(!showArtifacts)}>
                    <span>{i18n.t('show_artifacts')}</span>
                    {showArtifacts ? <ImMinus size=".75rem" /> : <ImPlus size=".75rem" />}
                </button>
            </div>
            <div className="card-attributes">
                {runes && runes.map(rune => {
                    return <div key={`wrapper-${rune.id}`} className="row-with-input">
                        <div className="row-title">{rune.label}</div>
                        {rune.id !== 'cdmg' && <div>{bale[rune.id]}</div>}
                        <div className="input-wrapper">
                            {rune.id !== 'cdmg' && <span className="plus-icon">+</span>}
                            <Input key={rune.id} {...rune} changed={evt => updateForm(evt, rune.id)} />
                        </div>
                    </div>
                })}
                <div>
                    <Select {...skillUp} changed={evt => updateForm(evt, 'skill_up')} />
                </div>
            </div>
            <Artifacts artifacts={artifacts} changed={(evt, id) => onArtifactChange(evt, id)} withClass="desktop" />
        </div>
        {showArtifacts && <Artifacts artifacts={artifacts} changed={(evt, id) => onArtifactChange(evt, id)} withClass="mobile" />}
        <div className="row justify-content-around">
            <DamageResult {...resultData} {...artifacts} {...props} />
            <EHPResult {...resultData} {...artifacts} {...props} />
        </div>
        <div className="tip">{i18n.t('damage_helper')}</div>
    </div>
}

export default BaleDamage